const { REACT_APP_LOCAL_DEV } = process.env;

export const isLocalDev = Boolean(REACT_APP_LOCAL_DEV);
